import AuthI from '../interfaces/auth.interface'
import { AuthService } from '../services/auth.service'
import {
    AuthSignInPayloadT,
    AuthStateT,
    GetCodeResponseT,
    GetInfoResponseT,
    SetNewPasswordPayloadT,
} from '../types/auth.types'

const authService = new AuthService()

class AuthRealisation implements AuthI {
    signin(payload: AuthSignInPayloadT): Promise<AuthStateT> {
        return authService.signin(payload)
    }

    getCode(email: string): Promise<GetCodeResponseT> {
        return authService.getCode(email)
    }

    setNewPassword(payload: SetNewPasswordPayloadT): Promise<any> {
        return authService.setNewPassword(payload)
    }

    getInfo(): Promise<GetInfoResponseT> {
        return authService.getInfo()
    }
}

export const authRealisation = new AuthRealisation()
